import { OptionEntity } from '@/types/OptionEntity';

export enum FollowUpAccordionKeys {
  active = 'active',
  closed = 'closed',
}

export type FollowUpAccordionItem = OptionEntity<FollowUpAccordionKeys, string>;
